import React from 'react';
export default function VideoView(props) {
  return (
    <video className="videoAttachment" width="320" height="240" controls>
      <source src={props.media.url} type="video/mp4" />
    </video>
  );
}
